import React, {useState} from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Query} from "react-apollo";
import {Spinner} from "react-bootstrap";
import {SSOQuery} from "../apollo/queries/SSOQuery";
import CiberAlerts from "../util/Messages";

class SSOApp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: '',
      deviceId: "AFC" + Math.floor(Math.random() * ((999 - 100) + 1))

    };
  }

  setError(error) {
    this.setState({
      errorMessage: error
    });
  }

  render() {
    return (
      <>
        <Query query={SSOQuery} fetchPolicy={"network-only"} variables={{deviceId: this.state.deviceId}}>
          {({loading, error, data}) => {
            const [setShow] = useState(false);
            const handleShow = () => setShow(true);
            if (loading) {
              let spinners = [];
              for (let i = 0; i < 20; i++) {
                spinners.push(<Spinner animation="grow" className="align-item-center"/>)
              }
              return (
                <div className="card card-signin my-5 col-sm-12 border-left-0 " style={{background: "#003A72"}}>
                  <img alt="colsubsidio" className="justify-content-center align-self-center"
                    style={{maxWidth: "300px", paddingTop: "10%"}}
                    src="https://cmscolsubsitio.netactica.net/Portals/1107/logo.png?ver=2019-05-16-125847-977"/>.
                  <h2 className="card-title row justify-content-center align-self-center text-white">Cargando</h2>
                  <div className="card-body d-flex align-self-center">
                    {spinners}
                  </div>
                </div>);

            } else if (data && data.ssoLogin) {
              window.location.replace(data.ssoLogin);
            }

            return (
              <>
                {error ?
                  <div className="card card-signin my-5 col-sm-12 border-left-0 " style={{background: "#003A72"}}>
                    <img alt="colsubsidio" className="justify-content-center align-self-center"
                      style={{maxWidth: "300px", paddingTop: "10%"}}
                      src="https://cmscolsubsitio.netactica.net/Portals/1107/logo.png?ver=2019-05-16-125847-977"/>.
                    <div className="card-body d-flex align-self-center">
                      <CiberAlerts error={error} callBack={handleShow}/>
                    </div>
                  </div>
                  :
                  null
                }
              </>
            )

          }}
        </Query>
      </>
    );
  }
}

export default SSOApp;
